
import {Request} from "@/api/request";

type order = {
    basicset_id: number;
    id: number;
    user_id: number;
    coupon_text: string;
    pay_type: number;
    payment: number;
    order: any;
    order_car: any;
    order_message: any;
    offer: any;
    last_order_id: string;
    next_order_id: string
};
type parameterKey = keyof BillingParameter;
const carColumn: Array<{ label: string; prop: string }> = [
    {
        label: "车牌号码",
        prop: "code",
    },
    {
        label: "品牌车型",
        prop: "category_name",
    },
    {
        label: "开单时间",
        prop: "create_time_text",
    },
    {
        label: "送修人",
        prop: "send_for_repair",
    },
    {
        label: "VIN",
        prop: "vin",
    },
    {
        label: "会员号",
        prop: "user_id",
    },
    {
        label: "接车人",
        prop: "meet_vehicle",
    },
    {
        label: "手机号码",
        prop: "phone",
    },
];
type rules = {
    [k in string]: any;
};
const offefColumn: Array<column> = [
    {
        prop: "reference_price",
        label: "参考价",
        width: 84,
    },
    {
        prop: "quoted_price",
        label: "报价",
        width: 84,
    },
    {
        prop: "historical_price",
        label: "历史报价",
        width: 84,
    },
    {
        prop: "num",
        label: "数量",
        width: 84,
    },
    {
        prop: "salesman_id",
        label: "销售人",
        width: 84,
    },
    {
        prop: "builders_id",
        label: "施工人",
        width: 84,
    },
];
type offerData = {
    id: number;
    quoted_price: number;
    type: number;
    num: number;
    salesman_id: number;
    builders_type: number;
    builders_id: number;
    setyj: number;
};
const partsColumn: Array<column> = [
    {
        prop: "name",
        label: "配件名称",
        width: 84,
    },
    
    {
        prop: "specification",
        label: "规格",
        width: 84,
    },
    {
        prop: "encoding",
        label: "编码",
        width: 84,
    },
    {
        prop: "mountings_type_name",
        label: "配件分类",
        width: 84,
    },
    {
        prop: "mountings_brand_name",
        label: "品牌",
        width: 84,
    },
    {
        prop: "mountings_unit_name",
        label: "单位",
        width: 84,
    },
    {
        prop: "price",
        label: "价格",
        width: 84,
    },
    {
        prop: "stock",
        label: "库存",
        width: 84,
    },
];
type project = {
    id: number;
    project_type_pid: number;
    name: string;
};
type dialogSelect = {
    project_type_pid?: number;
    search?: string;
};
const return_cash_plan = {
    // return_cash_plan: [
    //     {
    //         required: true,
    //         validator: (rule: any, value: string, callback: Function) => {
    //             if (value) {
    //                 callback();
    //             } else {
    //                 callback(new Error("请选择返现方案"));
    //             }
    //         },
    //         trigger: "blur",
    //     },
    // ],
};
const serviceRules = {
    name: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                validateInput("请输入维修项目", value, callback);
            },
            trigger: "change",
        },
    ],
    price: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                validateInput("请输入工时费", value, callback);
            },
            trigger: "change",
        },
    ],
    ...return_cash_plan,
};
const partsRules = {
    name: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                validateInput("请输入配件名称", value, callback);
            },
            trigger: "change",
        },
    ],
    price: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                validateInput("请输入销售价", value, callback);
            },
            trigger: "change",
        },
    ],
    // specification: [
    //     {
    //         required: true,
    //         validator: (rule: any, value: string, callback: Function) => {
    //             validateInput("请输入规格", value, callback);
    //         },
    //         trigger: "change",
    //     },
    // ],
    // encoding: [
    //     {
    //         required: true,
    //         validator: (rule: any, value: string, callback: Function) => {
    //             validateInput("请输入编码", value, callback);
    //         },
    //         trigger: "change",
    //     },
    // ],
    // unit_id: [
    //     {
    //         required: true,
    //         validator: (rule: any, value: string, callback: Function) => {
    //             if (value) {
    //                 callback();
    //             } else {
    //                 callback(new Error("请选择单位"));
    //             }
    //         },
    //         trigger: "blur",
    //     },
    // ],
    ...return_cash_plan,
};
const ogoquantityList: Array<any> = [
    {
        value: 1,
        label: "1/4"
    },
    {
        value: 2,
        label: "1/2"
    },
    {
        value: 3,
        label: "3/4"
    },
    {
        value: 4,
        label: "1"
    },
];
const historDialogNav: Array<string> = ["本车辆", "同车型", "不限车型"];
const printColumn: Array<column> = [
    {
        prop: "num",
        label: "数量",
        width: 84,
    },
    {
        prop: "quoted_price",
        label: "单价",
        width: 84,
    },
    {
        prop: "quoted_price_sum",
        label: "金额",
        width: 84,
    },
];
const printProject: Array<column> = [
    {
        prop: "project_name",
        label: "项目名称",
        width: 84,
    },
    ...printColumn,
];
const printMountings: Array<column> = [
    {
        prop: "mountings_name",
        label: "配件名称",
        width: 84,
    },
    {
        prop: "project_name",
        label: "单位",
        width: 84,
    },
    ...printColumn,
];

import {defineComponent, ref, reactive, inject, onMounted, watch} from "vue";
import {useRoute, LocationQueryValue} from "vue-router";
import {
    getOrderCarInfo,
    getOrderCarSelectList,
    getOrderCarRepairunit,
    getCarBrand,
    getConstructors,
    getReceivingCar,
    getSetitembasicset,
    getInfoOrderOffer,
    postDelOrderOffer,
    getOrderCarProject,
    postAddOrderOfferV2,
    getProjectAcquire,
    postAddOrderOfferTemporary,
    getOrderCarMountings,
    getSelectList,
    postEditOrderOffer,
    postEditReceivingCar,
    postBindingUser,
    postUnBindUser,
    getPayQrcode,
    getInfoOrderOfferHistory,
    getCheckProjectGroup,
    getUserProject,
    getUserVipCards,
    postAddOrderOfferVip,
    changeCarForOrder,
    changeUserForOrder,
    getAllPartnerList,
    getFadeOrderCarInfo,
    getFadeReceivingCar,
    postFadeEditReceivingCar,
    postFadeDelOrderOffer,
    postFadeAddOrderOfferV2,
    postFadeAddOrderOfferTemporary,
    postFadeEditOrderOffer, getFadeInfoOrderOffer,
} from "@/api/http";
import {validateInput, validateClass} from "@/assets/js/formRules";
import {
    column,
    BillingParameter,
    offerTemporaryTemporary,
} from "@/assets/types/common";
// import PrintForm from "@/components/PrintForm.vue";

export default defineComponent({
    name: "fadeBillDetail",
    // components: { PrintForm },
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["接车开单", "开单详情"]);
        const headClass = inject("headClass");
        const router = useRoute();
        const orderstatus = ref('') as any;
        let userInfo = ref({} as any);
        let bindUserId = ref('');
        let changeCarData = reactive({
                changeDialogVisible:false,
                formRef:null,
                form_rules:null,
                form_status:0,
                form_carcode:"",
                form_itemindex:0,
                form:{
                    car_id:"",
                    car_code:"",
                    vin:"",
                    car_brand_id:"",
                    car_series_id:"",
                    units_id:""
                },
                car_series_data_a:[],
                carCity:"粤S",
                orderCarCode:"",
                citySelect:false,
                provinceText:"",
                provinceList:[ "京","津","冀","晋","蒙","辽","吉","黑","沪","苏","浙","皖","闽","赣","鲁","豫","鄂","湘","粤","桂","琼","渝","川","贵","云","藏","陕","甘","青","宁","新"],
                cityText:"",
                carList: [] as any,
            }),
            //查询车辆
            _dialogCarcode = (e: any) => {
                changeCarData.form_status = (e == '' ? 0 : 1)
                var carcode = changeCarData.carCity + e
                
                changeCarData.form.car_id = "";
                Request.axiosInstance({
                    url: 'adminapi/OrderCar/getcar',
                    data: {car_code: carcode}
                }).then((res: any) => {
                    changeCarData.carList = res?.content?.list || []
                    changeCarData.form_carcode = carcode
                })
            },
            _form_addcar = (index: number) => {
                
                changeCarData.form_status =  (index == null ? 2 : 3);
                changeCarData.form_itemindex = index;
                changeCarData.form.car_code = changeCarData.carCity + changeCarData.orderCarCode
                if(changeCarData.form_status == 3)
                {
                    //选择现有车辆的时候，赋值车id
                    let detail = changeCarData.carList[index];
                    // form.value.vin = detail.vin
                    // form.value.car_brand_id = detail.car_brand_id
                    // form.value.car_series_id = detail.car_series_id
                    // form.value.car_category_id = detail.car_category_id
                    changeCarData.form.car_id = detail.id;
                }
            },
            setCarCity = (value: string) => {
                changeCarData.carCity = changeCarData.provinceText + value;
                changeCarData.citySelect = false;
                changeCarData.provinceText = "";
            },
            carChangeSubmit = (()=>{
                console.log(changeCarData.form);
                changeCarForOrder({...changeCarData.form,order_id:orderDetail.value.id}).then(()=>{
                
                });
                changeCarData.changeDialogVisible = false;
            }),
            changeCarDataCarBrandChange = (e: number, key: parameterKey): void => {
                if(!e){
                    if (key == "car_brand_id_a"){
                        changeCarData.form.car_series_id = "";
                    }
                }else if (key == "car_brand_id_a") {
                    changeCarData.form.car_series_id = "";
                    getCarBrand({
                        brand_id: Number(changeCarData.form.car_brand_id),
                    }).then((res: any) => {
                        changeCarData.car_series_data_a = res?.content?.list || [];
                    });
                }
            };
        let select = reactive({
                project_type_data: [],
                partner_data: [] as any,
                reappearance_type_data: [],
                insurance_data: [],
                repairunit_data: [],
                car_brand_data: [],
                car_series_data: [],
                receive_data: [],
                branch_data: [],
                mountings_type_data: [],
                mountings_type_p_data: [],
                mountings_unit_data: [],
                car_check_group:[]
            }),
            projectDiaData = reactive({
                selectVipIndex:0
            }),
            formRef = ref(null),
            rules = reactive({
                // mitplant: [
                //     {
                //         required: false,
                //         validator: (
                //             rule: any,
                //             value: string,
                //             callback: Function
                //         ) => {
                //             validateInput("请输入进厂里程", value, callback);
                //         },
                //         trigger: "change",
                //     },
                // ],
                // ogoquantity: [
                //     {
                //         required: false,
                //         validator: (
                //             rule: any,
                //             value: string,
                //             callback: Function
                //         ) => {
                //             validateInput("请输入油表油量", value, callback);
                //         },
                //         trigger: "change",
                //     },
                // ],
                // edtime: [
                //     {
                //         required: false,
                //         validator: (
                //             rule: any,
                //             value: string,
                //             callback: Function
                //         ) => {
                //             validateInput("请选择交车时间", value, callback);
                //         },
                //         trigger: "change",
                //     },
                // ],
                // maintenance: [
                //     {
                //         required: false,
                //         validator: (
                //             rule: any,
                //             value: string,
                //             callback: Function
                //         ) => {
                //             validateInput("请输入服务描述", value, callback);
                //         },
                //         trigger: "change",
                //     },
                // ],
            } as rules),
            orderDetail = ref({offer: [[], []]} as order),
            qrcodeImgeUrl = ref(''),
            orderNavIndex = ref(0),
            orderNav = ref([
                "接车信息",
                "报价信息",
                "车辆信息",
                "开单信息",
                "会员信息",
                "付款信息",
            ]),
            orderDetailLoading = ref([false, false, false] as Array<boolean>),
            dialogNavIndex = ref(0),
            serviceDialog = ref(false),
            partsDialog = ref(false),
            isPrint = ref(false),
            isProject = ref(false),
            isMountings = ref(false),
            dialogSelect = ref({} as dialogSelect),
            serviceTable = ref([]),
            //已购套餐列表
            userPackage = ref([]),
            //已购Vip
            userVipCards = ref([]),
            save_order_id = ref('') as any,
            partsTable = ref([]),
            is_all = ref(false),
            historDialog = ref(false),
            historDialogNavIndex = ref(0),
            historDialogData = reactive({
                data:[]
            }),
            selectData: Array<project> = [],
            serviceForm = ref({
                name: "",
                price: null,
                return_cash_plan: null,
            }),
            serviceFormNode = ref(null),
            partsForm = ref({
                ...serviceForm.value,
                encoding: null,
                specification: "",
                unit_id: null,
            }),
            partsFormNode = ref(null),
            isChoiceSale = ref(false),
            choiceOfferData: any = null,
            buildersList = ref([]),
            isChoiceBuilders = ref(false),
            buildersType = ref(1),
            printTabbleHeader = ref(
                [] as Array<{
                    name: string;
                    value: string;
                }>
            ),
            // 打印的表单
            printData = {
                id: "#print",
                startCallback() {
                },
            };
        
        let getSelectData = () => {
                getOrderCarSelectList().then((res: any) => {
                    if (res.status == 200) {
                        select.project_type_data =
                            res.content.project_type_data;
                        //select.partner_data = res.content.project_type_data;
                        select.insurance_data = res.content.insurance_data;
                    }
                    Object.assign(select, res?.content || {});
                    getAllPartnerList({}).then((res:any)=>{
                        //select.partner_data = res?.content?.list || [];
                        //console.log(select.partner_data)
                        for (const re of res.content.list) {
                            select.partner_data.push({
                                id:re.id,
                                name:re.name
                            })
                        }
                    });
                });
                getOrderCarRepairunit({}).then((res: any) => {
                    select.repairunit_data = res?.content?.list || [];
                });
                getCarBrand({}).then((res: any) => {
                    select.car_brand_data = res?.content?.list || [];
                });
                getConstructors({}).then((res: any) => {
                    select.branch_data = res?.content?.branch || [];
                    select.receive_data = res?.content?.staff || [];
                });
                getCheckProjectGroup({}).then((res:any)=>{
                    select.car_check_group = res?.content?.list || [];
                });
            },
            columnChange = (type: number): void => {
                switch (type) {
                    case 0:
                        // 更换车辆尚未对接
                        changeCarData.changeDialogVisible = true;
                        changeCarData.form_status = 0;
                        changeCarData.orderCarCode = '';
                        changeCarData.form = {
                            car_id:"",
                            car_code:"",
                            vin:"",
                            car_brand_id:"",
                            car_series_id:"",
                            units_id:""
                        };
                        break;
                    case 1:
                        getOrderCarDetail(orderDetail.value.last_order_id);
                        // 更换车辆尚未对接
                        break;
                    case 2:
                        getOrderCarDetail(orderDetail.value.next_order_id);
                        // 下一次服务
                        break;
                }
            },
            getOrderDetail = (index: number) => {
                switch (index) {
                    case 1:
                        getSetitembasicset({
                            basicset_id: orderDetail.value.basicset_id,
                            scene: "edit1",
                        }).then((res: any) => {
                            if (res.status == 200) {
                                // res.content.forEach((item: any) => {
                                //     if (rules[item.setitem_english as string]) {
                                //         rules[
                                //             item.setitem_english as string
                                //             ][0].required = true;
                                //     }
                                // });
                            }
                        });
                        //getOrderCarDetail(orderDetail.value.basicset_id);
                        break;
                    case 2:
                        getFadeInfoOrderOffer({
                            order_id: orderDetail.value.id,
                        }).then((res: any) => {
                            if (res.status == 200) {
                                let list: Array<offerData[]> = [[], []];
                                res.content.list.forEach((item: offerData) => {
                                    if (item.type == 1) {
                                        list[0].push(item);
                                    } else {
                                        list[1].push(item);
                                    }
                                });
                                if (list[0].length > 0) {
                                    isProject.value = true;
                                }
                                if (list[1].length > 0) {
                                    isMountings.value = true;
                                }
                                orderDetail.value.offer = list;
                                console.log(orderDetail.value)
                            }
                        });
                        
                        //getOrderCarDetail(orderDetail.value.basicset_id);
                        break;
                }
                
            },
            saveCarInfoChange = (e: any, key: string) => {
                if (key == "nmtime" || key == "aidue" || key == "ccidue" || key == "compulsory_insurance_due" || key == "purchase_time") {
                    if (e) {
                        e = new Date(e).getTime() / 1000;
                        //orderDetail.value.order.order_car.key = e
                        orderDetail.value.order.order_car[key] = e;
                    } else {
                        //orderDetail.value.order.order_car.key = ''
                        orderDetail.value.order.order_car[key] = '';
                    }
                    
                }
                // let nmtime = orderDetail.value.order.order_car.nmtime/1000;
                //     let aidue = orderDetail.value.order.order_car.aidue/1000;
                //     let ccidue = orderDetail.value.order.order_car.ccidue/1000;
                //     let purchase_time = orderDetail.value.order.order_car.purchase_time/1000;
                postFadeEditReceivingCar({
                    ...orderDetail.value.order.order_car,
                    order_id: orderDetail.value.id,
                    edit_type: '2'
                }).then((res) => {
                    getFadeReceivingCar({order_id: router.query.id}).then(
                        (res: any) => {
                            if (res.status == 200) {
                                orderDetail.value.order = res.content;
                            }
                        }
                    );
                });
            },
            editReceivingCar = (
                e: any,
                edit_type: number,
                key: string
            ): void => {
                let data: any = {
                    edit_type,
                    order_id: orderDetail.value.id,
                };
                
                if (e) {
                    if (key == "edtime") {
                        e = new Date(e).getTime() / 1000;
                        orderDetail.value.order.order_receiving_car.edtime = e
                    }
                    data[key] = e;
                    postFadeEditReceivingCar(data).then((res) => {
                        getFadeReceivingCar({order_id: router.query.id}).then(
                            (res: any) => {
                                if (res.status == 200) {
                                    orderDetail.value.order = res.content;
                                }
                            }
                        );
                    });
                } else {
                    if (key == "ogoquantity") {
                        orderDetail.value.order.order_receiving_car.ogoquantity = '';
                        postFadeEditReceivingCar(data).then((res) => {
                            getFadeReceivingCar({order_id: router.query.id}).then(
                                (res: any) => {
                                    if (res.status == 200) {
                                        orderDetail.value.order = res.content;
                                    }
                                }
                            );
                        });
                    }
                }
            },
            DetailselectChange = (e: number, key: parameterKey) => {
                orderDetail.value.order.order_car[key] = e;
                if (key == "car_brand_id") {
                    getCarBrand({
                        brand_id:
                        orderDetail.value.order.order_car.car_brand_id,
                    }).then((res: any) => {
                        select.car_series_data = res?.content?.list || [];
                        orderDetail.value.order.order_car[
                            "car_series_id"
                            ] = null;
                    });
                }
            },
            deleteOffer = (order_offer_id: number): void => {
                postFadeDelOrderOffer({order_offer_id}).then((res: any) => {
                    
                    getOrderDetail(2);
                    
                    (orderDetail.value as any).project_offer_price = res?.content.project_offer_price;
                    (orderDetail.value as any).mountings_offer_price = res?.content.mountings_offer_price;
                    (orderDetail.value as any).order_offer_price = res?.content.order_offer_price
                });
            },
            //手动输入一个历史报价
            quotedPriceChange = (item: offerData): void => {
                let data = {
                    order_offer_id: item.id,
                    quoted_price: item.quoted_price,
                };
                editOrderOffer(data);
            },
            //输入配件数量修改报价信息
            mountingsNumberChange = (item: offerData) => {
                let data = {
                    order_offer_id: item.id,
                    num: item.num,
                };
                editOrderOffer(data);
            },
            //切换历史报价
            historyChangeClick = (index: number) => {
                historDialogNavIndex.value = index;
                getHistoryPriceData();
            },
            //点击查看历史报价
            selectHistor = (item: offerData): void => {
                choiceOfferData = item;
                getHistoryPriceData();
            },
            getHistoryPriceData = () => {
                getInfoOrderOfferHistory({
                    order_offer_id: choiceOfferData.id,
                    type: Number(historDialogNavIndex.value) + 1
                }).then((res: any) => {
                    if (res.status == 200) {
                        historDialogData.data = res.content.list;
                        historDialog.value = true;
                    }
                });
            },
            //选择一个历史报价
            historPriceChange = (item: any) => {
                let data = {
                    order_offer_id: choiceOfferData.id,
                    quoted_price: item.quoted_price,
                };
                historDialog.value = false;
                historDialogNavIndex.value = 0;
                historDialogData.data = [];
                editOrderOffer(data);
            },
            editOrderOffer = (data: any) => {
                postFadeEditOrderOffer(data).then((res: any) => {
                    if (res.status == 202) {
                        getOrderDetail(2);
                        (orderDetail.value as any).project_offer_price = res?.content.project_offer_price;
                        (orderDetail.value as any).mountings_offer_price = res?.content.mountings_offer_price;
                        (orderDetail.value as any).order_offer_price = res?.content.order_offer_price
                        
                        
                    }
                });
            },
            addOffer = (index: number) => {
                if (index == 0) {
                    //添加项目
                    serviceDialog.value = true;
                    setTimeout(() => {
                        if(serviceFormNode.value){
                            (serviceFormNode.value as any).resetFields();
                        }
                    }, 500);
                    
                    getOrderProject();
                } else {
                    //添加配件
                    partsDialog.value = true;
                    setTimeout(() => {
                        (partsFormNode.value as any).resetFields();
                    }, 500);
                    getSelectList({data: "mountings_unit_data"}).then(
                        (res: any) => {
                            select.mountings_unit_data = res?.content || [];
                        }
                    );
                    getOrderMountings();
                }
                getProjectAcquire({data: "reappearance_type_data"}).then(
                    (res: any) => {
                        select.reappearance_type_data =
                            res?.content?.list || [];
                    }
                );
                //每次点击添加重置dialogNavIndex的值
                dialogNavIndex.value = 0;
                dialogSelect.value = {};
            },
            getOrderProject = (): void => {
                getOrderCarProject(dialogSelect.value).then((res: any) => {
                    serviceTable.value = res?.content?.project?.list || [];
                    select.project_type_data =
                        res?.content?.project_type?.list || [];
                });
                getUserProject({order_id:router.query.id}).then((res: any)=>{
                    userPackage.value = res?.content?.list || [];
                });
                getUserVipCards({order_id:router.query.id}).then((res: any)=>{
                    userVipCards.value = res?.content?.list || [];
                });
            },
            getOrderMountings = (): void => {
                getOrderCarMountings({...dialogSelect.value,limit:10,is_temporary:1}).then((res: any) => {
                    partsTable.value = res?.content?.mountings_data?.list || [];
                    select.mountings_type_data =
                        res?.content?.mountings_type?.list || [];
                    select.mountings_type_p_data =
                        res?.content?.mountings_type_p?.list || [];
                });
            },
            dialogSelectChange = (
                value: string | number,
                key: keyof dialogSelect
            ): void => {
                if (!value) {
                    delete dialogSelect.value[key];
                }
                if (serviceDialog.value) {
                    getOrderProject();
                } else {
                    //getOrderMountings();
                    getOrderCarMountings({...dialogSelect.value}).then((res: any) => {
                        partsTable.value = res?.content?.mountings_data?.list || [];
                        select.mountings_type_data =
                            res?.content?.mountings_type?.list || [];
                        select.mountings_type_p_data =
                            res?.content?.mountings_type_p?.list || [];
                    });
                }
            },
            isAllChange = (type: boolean): void => {
                is_all.value = !is_all.value;
                if (!is_all.value) {
                    if (selectData.length == 0) {
                        return;
                    } else {
                        let list = selectData.map((item: any) => item.id);
                        addOrderOffer(list.join(","));
                    }
                }
            },
            handleSelectionChange = (selection: Array<project>): void => {
                selectData = selection;
            },
            //选中当前项目和配件
            handleCurrentChange = (selection: project): void => {
                if (!is_all.value && selection) {
                    
                    addOrderOffer(selection.id);
                }
            },
            //添加项目和配件报价
            addOrderOffer = (id: number | string): void => {
                postFadeAddOrderOfferV2({
                    order_id: orderDetail.value.id,
                    type: serviceDialog.value ? 1 : 2,
                    id,
                }).then((res: any) => {
                    if (res.status == 202) {
                        getOrderDetail(2);
                        (orderDetail.value as any).project_offer_price = res?.content.project_offer_price;
                        (orderDetail.value as any).mountings_offer_price = res?.content.mountings_offer_price;
                        (orderDetail.value as any).order_offer_price = res?.content.order_offer_price
                    }
                    
                    
                });
                serviceDialog.value = false;
                partsDialog.value = false;
            },
            
            AddOrderOfferTemporary = (data: offerTemporaryTemporary): void => {
                postFadeAddOrderOfferTemporary(data).then((res: any) => {
                    res.status == 202 && addOrderOffer(res.content.id);
                });
            },
            addService = (type: boolean): void => {
                if (type) {
                    (serviceFormNode.value as any).validate(
                        (valid: boolean) => {
                            if (valid) {
                                let data = {
                                    type: 1,
                                    ...serviceForm.value,
                                };
                                AddOrderOfferTemporary(data);
                            }
                        }
                    );
                } else {
                    (partsFormNode.value as any).validate((valid: boolean) => {
                        if (valid) {
                            let data = {
                                type: 2,
                                ...partsForm.value,
                            };
                            AddOrderOfferTemporary(data);
                        }
                    });
                }
            },
            // 报价信息列表修改施工人与开单信息修改接车人共用，接车人是false
            choiceSalesman = (
                item: offerTemporaryTemporary | boolean
            ): void => {
                if (item==false && orderstatus.value>3){
                    return;
                }
                choiceOfferData = item;
                isChoiceSale.value = true;
            },
            //选择销售人员后报价信息修改
            saleChange = (salesman_id: number): void => {
                if (choiceOfferData) {
                    let data = {
                        order_offer_id: (choiceOfferData as offerTemporaryTemporary)
                            .id,
                        salesman_id,
                    };
                    
                    editOrderOffer(data);
                } else {
                    editReceivingCar(salesman_id, 3, "meet_vehicle_id");
                }
                isChoiceSale.value = false;
            },
            //报价信息的施工人（offerTemporaryTemporary）和开单信息的施工人（false），点击触发弹窗
            choiceBuilders = (
                item: offerTemporaryTemporary | boolean
            ): void => {
                if (item==false && orderstatus.value>3){
                    return;
                }
                choiceOfferData = item;
                isChoiceBuilders.value = true;
                buildersList.value = [];
                buildersType.value = 1;
            },
            //
            buildersChange = (): void => {
                let builders_id =
                    buildersList.value.length > 1
                        ? buildersList.value.join(",")
                        : buildersList.value[0];
                if (choiceOfferData) {//说明是点击报价信息的施工人弹窗
                    let data = {
                        builders_type: buildersType.value,
                        order_offer_id: (choiceOfferData as offerTemporaryTemporary)
                            .id,
                        builders_id,
                    };
                    editOrderOffer(data);
                } else {//修改开单信息的施工人
                    //editReceivingCar(builders_id, 3, "constructors_id");
                    let data: any = {
                        edit_type:3,
                        order_id: orderDetail.value.id,
                        constructors_id:builders_id,
                        constructors_type: buildersType.value
                    };
                    postFadeEditReceivingCar(data).then((res) => {
                        getFadeReceivingCar({order_id: router.query.id}).then(
                            (res: any) => {
                                if (res.status == 200) {
                                    orderDetail.value.order = res.content;
                                }
                            }
                        );
                    });
                    
                }
                
                isChoiceBuilders.value = false;
            },
            bindingUser = (): void => {
                // postBindingUser({
                //     order_id: orderDetail.value.id,
                //     user_id: orderDetail.value.user_id,
                // }).then((res) => {
                //     if (res.status == 202) {
                //         orderDetailChange(orderDetail.value.id);
                //     }
                // });
            },
            //选择已购套餐
            myPackageSelect = (selection:any)=>{
                // if(!selection) return;
                // postAddOrderOfferV2({
                //     order_id: orderDetail.value.id,
                //     type: serviceDialog.value ? 1 : 2,
                //     id:selection.project_id,
                //     project_type:2,
                //     package_id:selection.order_id
                // }).then((res: any) => {
                //     if (res.status == 202) {
                //         getOrderDetail(2);
                //         (orderDetail.value as any).project_offer_price = res?.content.project_offer_price;
                //         (orderDetail.value as any).mountings_offer_price = res?.content.mountings_offer_price;
                //         (orderDetail.value as any).order_offer_price = res?.content.order_offer_price
                //     }
                // });
                serviceDialog.value = false;
                partsDialog.value = false;
            },
            //选择vip卡
            myVipPackageSelect = (selection:any)=>{
                // if(!selection) return;
                // //尊享卡还要自动添加相关的配件，并且不能修改
                // postAddOrderOfferV2({
                //     order_id: orderDetail.value.id,
                //     type: serviceDialog.value ? 1 : 2,
                //     id:selection.vip_class_id,
                //     project_type:3,
                //     vip_id:selection.order_id
                // }).then((res: any) => {
                //     if (res.status == 202) {
                //         getOrderDetail(2);
                //         (orderDetail.value as any).project_offer_price = res?.content.project_offer_price;
                //         (orderDetail.value as any).mountings_offer_price = res?.content.mountings_offer_price;
                //         (orderDetail.value as any).order_offer_price = res?.content.order_offer_price
                //     }
                // });
                serviceDialog.value = false;
                partsDialog.value = false;
            },
            unBindUser = (): void => {
                // postUnBindUser({
                //     order_id: orderDetail.value.id
                // }).then((res) => {
                //     if (res.status == 202) {
                //         orderDetailChange(orderDetail.value.id);
                //     }
                // });
            },
            orderDetailChange = (
                order_id: string | null | number | LocationQueryValue[]
            ): void => {
                // getOrderCarInfo({order_id}).then((res: any) => {
                //     res.status == 200 && (orderDetail.value = res.content.info);
                // });
                getOrderCarDetail(order_id as any);
            },
            // 触发打印
            bindPrint = (): void => {
                isPrint.value = true;
                console.log(isPrint.value)
                setTimeout(() => {
                    isPrint.value = false;
                    console.log(isPrint.value)
                }, 1)
            },
            handleClose = (): void => {
                isPrint.value = false;
            },
            //提交订单绑定用户修改
            changeOrderUser = ()=>{
                // changeUserForOrder({userId:bindUserId.value,order_id:orderDetail.value.id}).then(()=>{
                //
                // });
            },
            getOrderCarDetail = (order_id: string | null | LocationQueryValue[]): void => {
                orderDetail.value = ({offer: [[], []]} as order);
                let data = {order_id};
                // 获取支付二维码
                // getPayQrcode(data).then((res: any) => {
                //     if (res.status == 200) {
                //         qrcodeImgeUrl.value = res.content.qrcode_image
                //     }
                // });
                getFadeOrderCarInfo(data).then((res: any) => {
                    let order = res?.content?.info || {};
                    orderstatus.value = res?.content?.info.orderstatus;
                    getFadeReceivingCar(data).then(async (res: any) => {
                        if (res.status == 200) {
                            orderDetail.value = order;
                            console.log('订单式',orderDetail.value);
                            orderDetail.value.order = res.content;
                            orderNavIndex.value = 0;
                            // 获取选中的车品牌下的车系
                            if (res.content.order_car) {
                                getCarBrand({
                                    brand_id:
                                    res.content.order_car.car_brand_id,
                                }).then((res: any) => {
                                    select.car_series_data =
                                        res?.content?.list || [];
                                });
                            }
                            for (let i of "123") {
                                let index = Number(i);
                                orderDetailLoading.value[index] = true;
                                await getOrderDetail(index);
                                orderDetailLoading.value[index] = false;
                            }
                        }
                    });
                });
                
                getSelectData();
            };
        onMounted(() => {
            let user_info = localStorage.getItem('user_info')
            if(user_info){
                userInfo.value = JSON.parse(user_info)
            }
            save_order_id.value = router.query.id;
            console.log('路由是'+save_order_id.value);
            orderstatus.value = router.query.orderStatus;
            getOrderCarDetail(router.query.id);
        });
        watch(buildersType, (newValue, oldValue) => {
            buildersList.value = [];
        });
        
        return {
            headClass,
            userInfo,
            select,
            formRef,
            rules,
            orderDetail,
            carColumn,
            orderNavIndex,
            orderNav,
            serviceDialog,
            partsDialog,
            dialogSelect,
            partsColumn,
            serviceTable,
            partsTable,
            is_all,
            dialogNavIndex,
            historDialog,
            historDialogNav,
            historDialogNavIndex,
            historDialogData,
            orderDetailLoading,
            offefColumn,
            serviceForm,
            serviceRules,
            serviceFormNode,
            partsForm,
            partsFormNode,
            partsRules,
            isChoiceSale,
            buildersList,
            isChoiceBuilders,
            buildersType,
            printData,
            qrcodeImgeUrl,
            printTabbleHeader,
            bindPrint,
            isPrint,
            isProject,
            isMountings,
            columnChange,
            editReceivingCar,
            DetailselectChange,
            deleteOffer,
            quotedPriceChange,
            isAllChange,
            addOffer,
            dialogSelectChange,
            handleSelectionChange,
            handleCurrentChange,
            addService,
            choiceSalesman,
            saleChange,
            choiceBuilders,
            buildersChange,
            bindingUser,
            unBindUser,
            selectHistor,
            historPriceChange,
            saveCarInfoChange,
            ogoquantityList,
            orderstatus,
            historyChangeClick,
            mountingsNumberChange,
            myPackageSelect,
            myVipPackageSelect,
            userPackage,
            userVipCards,
            projectDiaData,
            changeCarData,
            changeCarDataCarBrandChange,
            carChangeSubmit,
            setCarCity,
            _dialogCarcode,
            _form_addcar,
            changeOrderUser,
            bindUserId
        };
    },
});
